import React from "react";
import LocalIcon from "./LocalIcon";

const MaterialIcon = ({ name, isActive, className = "", selected = false, ...props }) => {
  return (
    <LocalIcon 
      icon={name}
      className={className}
      size={32}
      color={isActive ? 'var(--color-text-primary)' : 'var(--color-text-muted)'}
      {...props}
    />
  );
};

export default MaterialIcon; 